@for (field of searchObject.overview_simple; track $index) {
  <div class="search-tile-overview-fields">
    @if ($index < 2) {
      <div
        class="search-tile-overview-fields__value"
        [ngClass]="{'line2': $index === 0,
                    'line3': $index === 1}"
      >
        @if (!field.artifact_id) {
          <span [innerHTML]="field.value"></span>
        }
        @else {
          <span>
            <app-object-url [object]="field">
              <div class="object-url-content">
                <span class="text-link">
                  {{field.value}}
                </span>
              </div>
            </app-object-url>
          </span>
        }
      </div>
    }
  </div>
}
